export var DatePresetOption;
(function (DatePresetOption) {
    DatePresetOption[DatePresetOption["Default"] = 0] = "Default";
    DatePresetOption[DatePresetOption["SevenDays"] = 1] = "SevenDays";
    DatePresetOption[DatePresetOption["OneMonth"] = 2] = "OneMonth";
    DatePresetOption[DatePresetOption["ThreeMonths"] = 3] = "ThreeMonths";
    DatePresetOption[DatePresetOption["OneYear"] = 4] = "OneYear";
    DatePresetOption[DatePresetOption["PrevMonth"] = 5] = "PrevMonth";
})(DatePresetOption || (DatePresetOption = {}));
